export const REQUEST_BOOK = 'REQUEST_BOOK';
export const SUCCESS_BOOK = 'SUCCESS_BOOK';
export const FAILURE_BOOK = 'FAILURE_BOOK';
export const CLEAR_BOOK = 'CLEAR_BOOK';
